import { SalesClient } from 'api';
import CasesApplicationsTable from './ClientsTable';
import { DashboardFilter } from '../types';
import { DropdownOption } from 'components/common/OptionDropdown/OptionDropdown';

export type CasesTableProps = {
    mobile: boolean;
    clientsApps: SalesClient[];
    clientsAppsForTable: SalesClient[];
    setClientsAppsForTable: (apps: SalesClient[]) => void;
    isClientsAppsLoading: boolean;
    reloadClients: () => void;
    onFilterChange: (filters: DashboardFilter) => void;
    organizations: DropdownOption[];
};

const CasesTable = ({
    mobile,
    clientsApps,
    clientsAppsForTable,
    setClientsAppsForTable,
    isClientsAppsLoading,
    reloadClients,
    onFilterChange,
    organizations,
}: CasesTableProps) => {
    return (
        <CasesApplicationsTable
            mobile={mobile}
            clientsApps={clientsApps}
            clientsAppsForTable={clientsAppsForTable}
            setClientsAppsForTable={setClientsAppsForTable}
            isClientsAppsLoading={isClientsAppsLoading}
            reloadClients={reloadClients}
            onFilterChange={onFilterChange}
            organizations={organizations}
        />
    );
};

export default CasesTable;
